<template>
  <div>
    <form method="post" :action="fiservLink" target="_target" id="fiserv-form">
      <input type="hidden" name="timezone" value="utc" />
      <input type="hidden" name="authenticateTransaction" value="true" />
      <input type="hidden" name="txntype" value="sale" />
      <input type="hidden" name="txndatetime" :value="fiservForm.txndatetime" />
      <input type="hidden" name="hash" :value="fiservForm.hash" />
      <input type="hidden" name="currency" value="702" />
      <input type="hidden" name="mode" value="payonly" />
      <input type="hidden" name="storename" :value="fiservForm.storename" />
      <input type="hidden" name="chargetotal" :value="fiservForm.chargetotal" />
      <input
        type="hidden"
        name="paymentMethod"
        :value="fiservForm.paymentMethod"
      />
      <input type="hidden" name="full_bypass" :value="false" />
      <input
        type="hidden"
        name="sharedsecret"
        :value="fiservForm.sharedsecret"
      />
      <input type="hidden" name="email" value="test@test.com" />
      <input type="hidden" name="language" value="en_EN" />
      <input
        type="hidden"
        name="responseSuccessURL"
        :value="fiservSuccessUrl"
      />
      <input type="hidden" name="responseFailURL" :value="fiservFailUrl" />
      <input type="hidden" name="hash_algorithm" value="sha256" />
      <input type="hidden" name="mobileMode" value="true" />
      <input type="hidden" name="token" :value="fiservForm.token" />
      <button type="submit" style="display: none" ref="submitButton">
        submit
      </button>
    </form>
  </div>
</template>

<script>
import apiUrls from "@/services/apiUrls";
export default {
  name: "FiservForm",
  props: {
    fiservUrl: String,
  },
  data() {
    return {
      fiservForm: {},
    };
  },
  computed: {
    fiservSuccessUrl() {
      return `${process.env.VUE_APP_BASE_URL}/${apiUrls.FISERV_SUCCESS}`;
    },
    fiservFailUrl() {
      return `${process.env.VUE_APP_BASE_URL}/${apiUrls.FISERV_FAIL}`;
    },
    fiservLink() {
      return this.fiservUrl ? this.fiservUrl : process.env.VUE_APP_FISERV_URL;
    },
  },
  created() {
    this.fiservForm = JSON.parse(sessionStorage.getItem("fiservForm"));
    console.log(this.fiservUrl);
  },
  mounted() {
    this.$refs.submitButton.click();
  },
};
</script>

<style></style>
